export { ProductRecommendations } from './product-recommendations'
